import React from "react";
import styles from './AirlineSelector.module.scss';
import FormikSearchSelector from "gui/components/formikSearchSelector/FormikSearchSelector";
import {components} from 'react-select';
import {Grid} from '@material-ui/core';
import {allowOnlyEnglishAutoConvert} from 'data/utils/shortcuts';
import AirlineLogo from 'gui/components/airlineLogo';

export interface IAirlineSelectorProps {
  label?: string;
  field?: any;
  queryAirline: (query) => Promise<any>;
}


const Option = ({children, ...restProps}) => {
  return (
    <components.Option {...restProps}>
      <Grid container>
        <Grid item xs={6} style={{paddingTop: 25, paddingBottom: 25}}>
          {restProps.data.value.name}
        </Grid>
        <Grid item xs={2}/>
        <Grid item xs={4} className={styles.airlineLogoContainer}>
          <AirlineLogo className={styles.airlineLogo}
                       ticketDetails={{originFlightCompany: restProps.data.value} as any}/>
        </Grid>
      </Grid>
    </components.Option>
  );
};

const NoOptionsMessage = () => {
  return (
    null
  );
};

const MenuList = props => (
  <components.MenuList
    {...props}>
    {props.children}
    <p>
      חפש/י לפי שם חברת תעופה או קוד
    </p>

  </components.MenuList>
);

const AirlineSelector = (props: IAirlineSelectorProps) => {
  return (
    <FormikSearchSelector
      className={styles.airlineSelector}
      options={props.field.value ? [{label: props.field.value.name, value: props.field.value}] : []}
      promiseOptions={props.queryAirline}
      components={{MenuList, Option, NoOptionsMessage}}
      onInputChange={value => allowOnlyEnglishAutoConvert(value).toLowerCase()}
      {...props}
      onChange={(airline: any) => {
        props.field.onChange({
          target: {
            name: props.field.name,
            value: airline || undefined,
          },
        });
      }}
      errorClassName={styles.errorContainer}

    />
  );
};

AirlineSelector.defaultProps = {
  field: {
    onChange: () => {
    },
    name: '',


  },
  queryAirline: () => Promise.resolve(),
};

export default AirlineSelector;
